import { motion } from "framer-motion";
import { TEAM } from "@/lib/data";

export const Team = () => {
  return (
    <section
      id="team"
      className="py-24 lg:py-32 max-w-7xl mx-auto px-6"
      data-testid="team-section"
    >
      <div className="mb-16 max-w-2xl">
        <p className="overline text-accent mb-6">03 / Our Team</p>
        <h2 className="font-display text-4xl sm:text-6xl leading-none tracking-tight text-foreground">
          The familiar faces <br />
          <em className="italic text-accent">behind the counter.</em>
        </h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {TEAM.map((m, i) => (
          <motion.div
            key={m.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group"
            data-testid={`team-member-${i}`}
          >
            <div className="overflow-hidden bg-secondary aspect-[3/4]">
              <img
                src={m.image}
                alt={m.name}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700 ease-out"
              />
            </div>
            <h3 className="mt-5 font-display text-2xl text-foreground leading-none tracking-tight">
              {m.name}
            </h3>
            <p className="mt-2 font-mono-label text-[0.65rem] uppercase tracking-widest text-accent">
              {m.role}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
